import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['bar', 'next', 'question']
  static values = { duration: Number }

  connect () {
    this.index = 0
    this.startTimer()
  }

  disconnect () {
    window.clearTimeout(this.timer)
  }

  next () {
    this.questionTargets[this.index].classList.add('hidden')
    this.index += 1
    this.questionTargets[this.index].classList.remove('hidden')
    this.startTimer()
  }

  startTimer () {
    const bar = this.barTargets[this.index]
    const next = this.nextTargets[this.index]
    next.classList.add('hidden')
    bar.style.transition = 'none'
    bar.style.width = '0%'

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        bar.style.transition = `width ${this.durationValue || 30}s linear`
        bar.style.width = '100%'
      })
    })

    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => {
      next.classList.remove('hidden')
    }, (this.durationValue || 30) * 1000)
  }
}
